export default __webpack_public_path__ + "static/media/logo.b424352e.svg";